class StickyHeader extends HTMLElement {
  constructor() {
    super();

    this.header = document.getElementById('shopify-section-header')
    this.headerBounds = {}
    this.currentScrollTop = 0
    this.breakpoint = 1365
    this.onScrollHandler = this.onScroll.bind(this)
    this.menuOpen = false
    this.details = this.querySelectorAll('details')
    this.siteContent = document.querySelector('[data-site-content]')
    this.siteBody = document.body
    this.siteHtml = document.querySelector('html')
    this.scrollPosition = 0
    this.bookingButton = document.getElementById('bookingButtonNavHeader')
    this.initDetails()
    this.setURLBookingButton()
  }

  async setURLBookingButton() {
    // Was hardcoded to the FYi page handles with no brand or locale awareness, so on
    // Visique it produced /pages/find-a-location (a 404 there) and on any secondary
    // locale it dropped the /en prefix and served the default-language page.
    if (!this.bookingButton) return
    const root      = window.BH_LOCALE_ROOT || ''
    const isVisique = ((window.Shopify && window.Shopify.shop) || '').includes('visique')
    const bookPath  = isVisique ? '/pages/rendez-vous' : '/pages/book-an-appointment'
    const findPath  = isVisique ? '/pages/trouver-une-clinique' : '/pages/find-a-location'
    const prefClinic = localStorage.getItem('pc')
    this.bookingButton.setAttribute('href', prefClinic
      ? `${root}${bookPath}?locationId=${prefClinic}`
      : `${root}${findPath}`)
  }

  connectedCallback() {
    window.addEventListener('scroll', this.onScrollHandler, false);
    this.createObserver();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom && !this.menuOpen) {
      // Scroll Down
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      // Scroll Up
      requestAnimationFrame(this.reveal.bind(this));
    } else if (scrollTop <= this.headerBounds.top && !this.menuOpen) {
      // Scroll to top of page
      requestAnimationFrame(this.reset.bind(this));
    } else {
      requestAnimationFrame(this.reveal.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
    this.disclosures.forEach(disclosure => disclosure.close());
  }

  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    this.searchModal.close(false);
  }

  initDetails() {
    this.details.forEach(detail => {
      detail.addEventListener('toggle', () => {
        this.checkDetails()
      })
    })
  }

  checkDetails() {
    this.menuOpen = [...this.details].some(detail => detail.hasAttribute('open'))

    if (this.menuOpen) { return }
    this.onScroll()
  }
}

customElements.define('sticky-header', StickyHeader);

class HeaderSlider extends HTMLElement {
  constructor() {
    super();

    this.options = {
      loop: false,
      slidesPerView: 'auto',
      threshold: 10,
      noSwiping: false,
      draggable: true
    }

    this.swiperEl = this.querySelector('[data-swiper]')
    this.parentWrapper = this.closest('details')

    this.swiper = this.init()
    this.parentWrapper.addEventListener('toggle', this.update)
  }

  init() {
    const swiper = new Swiper(this.swiperEl, this.options)
    return swiper
  }

  update() {
    this.swiper?.update()
  }
}

customElements.define('header-slider', HeaderSlider);
